<!-- =========================================================================================
  File Name: VerticalNavMenuRight.vue
  Description: Vertical NavMenu Component
  Component Name: VerticalNavMenu
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="parentx">
    <vs-sidebar
      class="v-nav-menu items-no-padding"
      v-model="isVerticalNavMenuActive"
      ref="verticalNavMenu"
      default-index="-1"
      :click-not-close="clickNotClose"
      :reduce-not-rebound="reduceNotRebound"
      :parent="parent"
      :hiddenBackground="clickNotClose"
      :reduce="reduce"
      position-right
      v-hammer:swipe="onMenuSwipe"
    >
      <div @mouseenter="mouseEnter" @mouseleave="mouseLeave">
        <!-- Header -->
        <div
          class="header-sidebar flex items-end justify-between"
          slot="header"
          style="padding: 20px 19px 0px 23px !important"
        >
          <!-- Logo -->
          <span
            class="vx-logo-text"
            style="padding-top: auto; font-size: 18px"
            v-show="isMouseEnter || !reduce"
            v-if="title"
            >Quick Actions</span
          >

          <!-- /Logo -->
        </div>
        <!-- /Header -->
        <vs-divider />
        <!-- Header Shadow -->
        <div class="shadow-bottom" v-show="showShadowBottom" />

        <!-- Menu Items -->
        <component
          :is="scrollbarTag"
          ref="verticalNavMenuPs"
          class="scroll-area-v-nav-menu pt-2"
          :settings="settings"
          @ps-scroll-y="psSectionScroll"
          @scroll="psSectionScroll"
          :key="$vs.rtl"
        >
          <div class="section-header ml-3">Personal Todo</div>

          <tasks-day
            :date="today"
            category="personal"
            :tasks="tasksForMe"
            :showEye="false"
          />
        </component>
        <!-- /Menu Items -->
      </div>
    </vs-sidebar>

    <!-- Swipe Gesture -->
    <div
      v-if="!isVerticalNavMenuActive"
      class="v-nav-menu-swipe-area"
      v-hammer:swipe="onSwipeAreaSwipe"
    />
    <!-- /Swipe Gesture -->
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";

import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "v-nav-menu",
  components: {
    VuePerfectScrollbar,
  },
  props: {
    logo: { type: String },
    openGroupHover: { type: Boolean, default: false },
    parent: { type: String },
    reduceNotRebound: { type: Boolean, default: true },
    title: { type: String },
  },
  data: () => ({
    clickNotClose: false, // disable close navMenu on outside click
    isMouseEnter: false,
    reduce: false, // determines if navMenu is reduce - component property
    settings: {
      // perfectScrollbar settings
      maxScrollbarLength: 60,
      wheelSpeed: 1,
      swipeEasing: true,
    },
    showShadowBottom: false,
    today: moment(),
  }),
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      userVenues: "venues/venues",
      tasks: "venueTasks/tasks",
      userId: "users/userId",
    }),
    tasksForMe() {
      return this.tasks.filter((e) => e.responsibleUserId === this.userId);
    },
    // tasksForVenue() {
    //   return this.tasks.filter(
    //     (e) =>
    //       e.venueIds.includes(this.activeVenue.venueId) &&
    //       parseInt(e.startDateUtcTicks) > new Date().getTime()
    //   );
    // },
    isGroupActive() {
      return (item) => {
        const path = this.$route.fullPath;
        const routeParent = this.$route.meta
          ? this.$route.meta.parent
          : undefined;
        let open = false;

        let func = (item) => {
          if (item.submenu) {
            item.submenu.forEach((item) => {
              if (
                item.url &&
                (path === item.url || routeParent === item.slug)
              ) {
                open = true;
              } else if (item.submenu) {
                func(item);
              }
            });
          }
        };
        func(item);
        return open;
      };
    },
    isVerticalNavMenuActive: {
      get() {
        return this.$store.state.themeProps.isVerticalRightNavMenuActive;
      },
      set(val) {
        this.$store.commit("TOGGLE_IS_VERTICAL_RIGHT_NAV_MENU_ACTIVE", val);
      },
    },
    layoutType() {
      return this.$store.state.themeProps.mainLayoutType;
    },
    reduceButton: {
      get() {
        return this.$store.state.themeProps.reduceButton;
      },
      set(val) {
        this.$store.commit("TOGGLE_REDUCE_BUTTON", val);
      },
    },
    isVerticalRightNavMenuReduced() {
      return Boolean(this.reduce && this.reduceButton);
    },
    verticalRightNavMenuItemsMin() {
      return this.$store.state.themeProps.verticalRightNavMenuItemsMin;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    windowWidth() {
      return this.$store.state.themeProps.windowWidth;
    },
  },
  watch: {
    $route() {
      if (this.isVerticalRightNavMenuActive && this.showCloseButton)
        this.$store.commit("TOGGLE_IS_VERTICAL_RIGHT_NAV_MENU_ACTIVE", false);
    },
    reduce(val) {
      const verticalRightNavMenuWidth = val
        ? "reduced"
        : this.$store.state.themeProps.windowWidth < 1200
        ? "no-nav-menu"
        : "default";
      this.$store.dispatch(
        "updateVerticalRightNavMenuWidth",
        verticalRightNavMenuWidth
      );

      setTimeout(function () {
        window.dispatchEvent(new Event("resize"));
      }, 100);
    },
    layoutType() {
      this.setVerticalRightNavMenuWidth();
    },
    reduceButton() {
      this.setVerticalRightNavMenuWidth();
    },
    windowWidth() {
      this.setVerticalRightNavMenuWidth();
    },
  },
  methods: {
    toggleSidebar() {
      this.isSidebarActive = !this.isSidebarActive;
    },
    trimName(str) {
      return str.length > 15 ? str.substring(0, 15) + "..." : str;
    },
    async switchVenue(venue) {
      console.log("Setting active venue for", venue.venueId);
      await this.$store.dispatch("venues/setActiveVenue", {
        venueId: venue.venueId,
      });

      this.activeVenue = this.$store.getters["venues/activeVenue"];

      this.$router.go();
    },
    onMenuSwipe(event) {
      // Swipe Right
      if (event.direction === 4 && this.$vs.rtl) {
        if (this.isVerticalRightNavMenuActive && this.showCloseButton)
          this.isVerticalRightNavMenuActive = false;
      }
      // Swipe Left
      else if (event.direction === 2 && !this.$vs.rtl) {
        if (this.isVerticalRightNavMenuActive && this.showCloseButton)
          this.isVerticalRightNavMenuActive = false;
      }
    },
    onSwipeAreaSwipe(event) {
      // Swipe Right
      if (event.direction === 4 && !this.$vs.rtl) {
        if (!this.isVerticalRightNavMenuActive && this.showCloseButton)
          this.isVerticalRightNavMenuActive = true;
      }
      // Swipe Left
      else if (event.direction === 2 && this.$vs.rtl) {
        if (!this.isVerticalRightNavMenuActive && this.showCloseButton)
          this.isVerticalRightNavMenuActive = true;
      }
    },
    psSectionScroll() {
      const scroll_el =
        this.$refs.verticalRightNavMenuPs.$el ||
        this.$refs.verticalRightNavMenuPs;
      this.showShadowBottom = scroll_el.scrollTop > 0 ? true : false;
    },
    mouseEnter() {
      if (this.reduce)
        this.$store.commit("UPDATE_VERTICAL_RIGHT_NAV_MENU_ITEMS_MIN", false);
      this.isMouseEnter = true;
    },
    mouseLeave() {
      if (this.reduce)
        this.$store.commit("UPDATE_VERTICAL_RIGHT_NAV_MENU_ITEMS_MIN", true);
      this.isMouseEnter = false;
    },
    setVerticalRightNavMenuWidth() {
      if (this.windowWidth > 1200) {
        if (this.layoutType === "vertical") {
          // Set reduce
          this.reduce = this.reduceButton ? true : false;

          // Open NavMenu
          this.$store.commit("TOGGLE_IS_VERTICAL_RIGHT_NAV_MENU_ACTIVE", true);

          // Set Menu Items Only Icon Mode
          const verticalRightNavMenuItemsMin =
            this.reduceButton && !this.isMouseEnter ? true : false;
          this.$store.commit(
            "UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN",
            verticalRightNavMenuItemsMin
          );

          // Menu Action buttons
          this.clickNotClose = true;
          this.showCloseButton = true;

          const verticalRightNavMenuWidth = this.isVerticalRightNavMenuReduced
            ? "reduced"
            : "default";
          this.$store.dispatch(
            "updateVerticalRightNavMenuWidth",
            verticalRightNavMenuWidth
          );

          return;
        }
      }

      // Close NavMenu
      this.$store.commit("TOGGLE_IS_VERTICAL_RIGHT_NAV_MENU_ACTIVE", false);

      // Reduce button
      if (this.reduceButton) this.reduce = false;

      // Menu Action buttons
      this.showCloseButton = false;
      this.clickNotClose = false;

      // Update NavMenu Width
      this.$store.dispatch("updateVerticalNavMenuWidth", "no-nav-menu");

      // Remove Only Icon in Menu
      this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", false);
    },
    toggleReduce(val) {
      this.reduceButton = val;
      this.setVerticalRightNavMenuWidth();
    },
  },
  mounted() {
    this.setVerticalRightNavMenuWidth();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/verticalNavMenu.scss";

.section-header {
  font-size: 1.2em;
  font-weight: bold;
}
</style>
